/* istanbul ignore file */
import { getLabelStyle } from './label-style';

export const getGlobalStyles = ({ palette = {}, semanticColors = {}, spacing = {} }) => ({
  '@global': Object.assign(getLabelStyle({ palette, semanticColors, spacing })),
});
